import {
    GET_BIRTHDAY,
    BI_LOADING
} from "../actions/BirthdayActions"

const initialState = {
    birthdays: [],
    loading: true,
};

const BirthdayReducer = function(state = initialState, action){
    switch (action.type) {
        case BI_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_BIRTHDAY: {
            return {
                ...state,
                birthdays: [...action.data],
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default BirthdayReducer;
  

